import { LEGAL_META } from './components/legalContent';

const GA_ID = 'G-91235XJS7P';
const CONSENT_KEY = 'bp_cookie_consent';
const CONSENT_VERSION_KEY = 'bp_cookie_consent_version';
const CONSENT_TIMESTAMP_KEY = 'bp_cookie_consent_at';

// Industry-standard re-ask window (Termly/CookieYes default to 6 months,
// Cookiebot to 12). Applied to both Accept and Decline alike — expiring
// only a "no" would be a dark pattern and isn't freely-given consent.
const CONSENT_TTL_DAYS = 180;

const isTrackableHost = () =>
    window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

// 'accepted' | 'declined' | null (no choice on record, or it has expired /
// was recorded against a since-changed Privacy Policy version)
export const getConsent = () => {
    const value = localStorage.getItem(CONSENT_KEY);
    if (!value) return null;

    if (localStorage.getItem(CONSENT_VERSION_KEY) !== LEGAL_META.version) return null;

    const storedAt = Number(localStorage.getItem(CONSENT_TIMESTAMP_KEY));
    const ageDays = (Date.now() - storedAt) / (1000 * 60 * 60 * 24);
    if (!storedAt || ageDays > CONSENT_TTL_DAYS) return null;

    return value;
};

export const setConsent = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    localStorage.setItem(CONSENT_VERSION_KEY, LEGAL_META.version);
    localStorage.setItem(CONSENT_TIMESTAMP_KEY, String(Date.now()));
};

// Injects gtag.js and fires the first pageview. Safe to call more than once —
// no-ops if GA is already loaded or the site is running on localhost.
export const loadGA = () => {
    if (!isTrackableHost() || typeof window.gtag === 'function') return;

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, { module_type: 'marketing' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
};

// Called once on app load — resumes tracking for a returning visitor who
// already accepted (and whose consent hasn't expired), without showing the
// banner again.
export const initAnalyticsFromConsent = () => {
    if (getConsent() === 'accepted') loadGA();
};
